// extracted by mini-css-extract-plugin
export default {"keycapContainer":"PrettyShortcuts_keycapContainer__BJnvU","combinedKeys":"PrettyShortcuts_combinedKeys__b6YeJ","privateButtonOverride":"PrettyShortcuts_privateButtonOverride__FSQmn"};